import { render } from "./MenuAbstract.vue?vue&type=template&id=48dcd2a4"
import script from "./MenuAbstract.vue?vue&type=script&lang=js"
export * from "./MenuAbstract.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonk/dev/projects/scoretrack-ionic-v7/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__